
<template>
  <div class="flight-report px-3 py-4 mb-4">

    <div v-if="!originalMailOrNot" class="text-danger py-3 px-4 rounded bg-light text-center mb-5">
      <i class="fa fa-user-secret pl-3"></i>
      {{ impersonateMail.split('@')[0] }}
    </div>

    <!-- No data -->
    <div v-if="!isPersonExist || !flightTimeRecords.length" class="empty-status ft-empty-status">
      <div class="icon">
        <i class="icons icon-user-unfollow"></i>
      </div>
      <div class="title">No Flight Time data Found.</div>
    </div>

    <!-- Flight Time Grid -->
    <div v-else class="fr-grid">
      <div
        v-for="flightTime in flightTimeRecords"
        :key="flightTime.rangeDescription"
        class="fr-card"
        :class="{ 'has-data': flightTime.actualHours > 0 }"
      >
        <div class="fr-card-top">
          <div>
            <div class="fr-month">{{ flightTime.rangeDescription }}</div>
            <div class="fr-year">{{ flightTime.dateRange }}</div>
          </div>
        </div>

        <div class="fr-date-grid">
          <span class="fr-date-pill">{{ flightTime.actualHours }}</span>
          <span class="fr-date-pill">/ {{ flightTime.requiredHours }} hrs</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'FlightReport',
  data() {
    return {
      flightTimeRecords: [],
      dayjs,
      isPersonExist: true,
      searchMail: localStorage.getItem('mail'),
    };
  },
  created() {
    this.retrieveFlightTime()
  },
  computed: {
    impersonateMail() {
      return this.$store.getters.impersonateMail;
    },
    originalMailOrNot() {
      if (this.impersonateMail !== '') {
        return this.impersonateMail === localStorage.getItem('mail');
      }
      return true;
    },
  },
  methods: {
    retrieveFlightTime() {
      const mail = this.impersonateMail ? { impersonate: this.impersonateMail.split('@')[0] } : ''
      this.getFlightTime(localStorage.getItem('access_token'), mail)
        .then(resp => {
          this.isPersonExist = true
          this.flightTimeRecords = resp.data.data.flightTimeList
        })
        .catch(err => {
          console.log('err', err)
          this.isPersonExist = false
        })
    },
  },
    watch: {
    impersonateMail(to) {
      this.retrieveFlightTime(to)
    }
  }
};
</script>

<style lang="scss" scoped>
.flight-report {
  max-width: 1000px;
  margin: 0 auto;
}

.fr-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  margin: 0 auto;
}

.fr-card {
  background: #ffffff;
  border: 1px solid #B99075;
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 120px;
  overflow: hidden;
}

.fr-card.has-data {
  border-color: #B99075;
  background: #ffffff;
}

.fr-month { font-size: 18px; font-weight: 500; color: #A17A5F; }
.fr-year  { font-size: 15px; color: #888; margin-top: 1px; }

.fr-date-grid {
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 4px;
  justify-content: start;
}

.fr-date-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap; 
  background: #EBE6E0;
  color: #A17A5F;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 15px;
  width: max-content;
}

.fr-card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.fr-date-grid {
  display: grid;
  grid-template-columns: repeat(3, min-content); 
  gap: 6px;
  justify-content: start;
}

.ft-empty-status {
  padding: 150px 0 0 0;
}

/* tablet */
@media (max-width: 768px) {
  .fr-grid {
    grid-template-columns: repeat(2, 1fr); /* 2 columns */
  }
}

/* phone */
@media (max-width: 480px) {
  .fr-grid {
    grid-template-columns: 1fr; /* 1 column */
  }
}
</style>
